import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Grid, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import _ from 'lodash';

import { SelectFieldMultiple, SelectFieldMultipleWithMore } from '../../../common/select_field';
import { getWarehouseDocumentTypeOptions, getWarehouseName } from '../../../common/utils/warehouse_utils';
import { getAllWarehousesState } from '../../../../features/inventory/get_all_warehouses';
import { WarehouseTypeEnum } from "../../../../core/enums/inventory/warehouse";
import FilterPaper from '../../../common/filter_paper';

const WarehouseDocumentFilters = ({
                                      queryParams,
                                      onSearchInputChange,
                                      onSelectWarehousesChange,
                                      onSelectTypesChange
                                  }) => {
    const getAllWarehouses = useSelector(getAllWarehousesState);

    const [warehouseIds, setWarehouseIds] = useState(queryParams?.warehouseId || []);
    const [types, setTypes] = useState(queryParams?.type || []);

    const onSearchInputChangeDebounced = _.debounce((value) => onSearchInputChange(value), 600);

    return (
        <FilterPaper title="Filtry dokumentów magazynowych">
            <Grid container spacing={ 3 } alignItems="flex-start">
                <Grid item xs={ 12 } sm={ 6 }>
                    <SelectFieldMultiple
                        size="small"
                        fullWidth
                        label="Rodzaj dokumentu"
                        options={ getWarehouseDocumentTypeOptions }
                        required
                        value={ types }
                        onClose={ () => onSelectTypesChange(types) }
                        onChange={ event => setTypes(event.target.value) }
                    />
                </Grid>

                <Grid item xs={ 12 } sm={ 6 }>
                    <TextField
                        size="small"
                        fullWidth
                        label="Szukaj po numerze"
                        defaultValue={ queryParams?.query || '' }
                        onChange={ event => onSearchInputChangeDebounced(event.target.value) }
                        InputProps={ {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon fontSize="small" color="action"/>
                                </InputAdornment>
                            ),
                        } }
                    />
                </Grid>

                <Grid item xs={ 12 }>
                    <SelectFieldMultipleWithMore
                        size="small"
                        fullWidth
                        label="Pokaż dla magazynów"
                        defaultOptions={ getAllWarehouses?.data?.filter(warehouse => warehouse?.type !== WarehouseTypeEnum.POD.value || warehouse?.pod?.serviceId != null).map(warehouse => ({
                            value: warehouse?.internalId,
                            label: getWarehouseName(warehouse)
                        })) || [] }
                        extraOptions={ getAllWarehouses?.data?.filter(warehouse => warehouse?.type === WarehouseTypeEnum.POD.value && warehouse?.pod?.serviceId == null).map(warehouse => ({
                            value: warehouse?.internalId,
                            label: getWarehouseName(warehouse)
                        })) || [] }
                        required
                        value={ warehouseIds }
                        onClose={ () => onSelectWarehousesChange(warehouseIds) }
                        onChange={ event => setWarehouseIds(event.target.value) }
                    />
                </Grid>
            </Grid>
        </FilterPaper>
    );
};

export default WarehouseDocumentFilters;